import { Component, HostListener, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SkeletonService } from '../shared/services/skeleton.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-ai-landing-page',
  templateUrl: './ai-landing-page.component.html',
  styleUrls: ['./ai-landing-page.component.scss']
})
export class AiLandingPageComponent implements OnInit {
  questionText: string = '';
  environment1: string = environment.s3bucket.url;
  isMobile: boolean = false;
  isDownArrow: boolean = false;
  
  processedBannerList: any[] = [  {
    "id": 903,
    "title": "NEW BANNER",
    "path": "ai-banner-image.png",
    "banner_link": "/product-list",
    "source": null,
    "from_date": "2025-05-26T00:00:00Z",
    "end_date": "2028-11-16T23:59:00Z",
    "priority": "1",
    "is_active": true,
    "page": "HOME",
    "lob": "",
    "sub_lob": null,
    "offer_id": null,
    "brand_type": null
  }];
  isLoading: boolean = false;
  hasDealerCode: boolean = false;
  isBannerMobile: boolean = false;

  constructor(public skeletonService: SkeletonService) {
    console.log('Banner URL:', this.environment1); // Debug log
  }

  ngOnInit() {
    // Initialize banner data
    this.isLoading = false;
    this.checkScreenSize();
  }

  // Banner carousel options
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: false,
    margin: 0,
    responsive: {
      0: {
        items: 1.15,
        stagePadding: 30
      },
      768: {
        items: 1.15,
        stagePadding: 30
      },
      992: {
        items: 1.15,
        stagePadding: 30
      }
    }
  };

  customOptionsForBanner: OwlOptions = {
    loop: false,
    margin: 10,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    responsive: {
      0: {
        items: 1.5
      },
      768: {
        items: 1.5
      },
      992: {
        items: 1.5
      }
    },
    nav: false
  };

  // Handle banner click
  GetTest(data: any) {
    console.log('Banner clicked:', data); // Debug log
    if (data?.banner_link) {
      window.location.href = data.banner_link;
    }
  }
  
  // FAQ items
  faqItems = [
    {
      question: 'Where can I take a test drive of the vehicle?',
      answer: 'Lorem ipsum dolor sit amet consectetur. Eget nulla et morbi proin aliquet. Eu nisi adipiscing consequat pulvinar nullam urna eu etiam areli pellentesque.',
      author: 'Tata Motors',
      date: '20 July, 2023',
      likes: 42,
      dislikes: 3
    },
    {
      question: 'What are the financing options available?',
      answer: 'Lorem ipsum dolor sit amet consectetur. Eget nulla et morbi proin aliquet. Eu nisi adipiscing consequat pulvinar nullam urna eu etiam areli pellentesque.',
      author: 'Tata Motors',
      date: '19 July, 2023',
      likes: 38,
      dislikes: 1
    },
    {
      question: 'How do I book a service appointment?',
      answer: 'Lorem ipsum dolor sit amet consectetur. Eget nulla et morbi proin aliquet. Eu nisi adipiscing consequat pulvinar nullam urna eu etiam areli pellentesque.',
      author: 'Tata Motors',
      date: '18 July, 2023',
      likes: 35,
      dislikes: 2
    }
  ];

  // FAQ Data
  qaData = {
    question: 'What are the financing options available?',
    answer: 'We offer multiple financing options including loans, leasing, and flexible payment plans to help you acquire your commercial vehicle. Our team can help you choose the best option based on your needs.',
    author: 'Tata Motors',
    date: '20 July, 2023',
    showBorder: true
  };

  // Vote count
  count: number = 42;

  chevronIcon: string = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  // Method to handle question submission
  onPostQuestion() {
    if (this.questionText.trim()) {
      // Create a new FAQ item
      const newFaq = {
        question: this.questionText,
        answer: 'Pending response from our team.',
        author: 'User',
        date: new Date().toLocaleDateString('en-US', { 
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }),
        likes: 0,
        dislikes: 0
      };
      
      // Add to the beginning of the list
      this.faqItems.unshift(newFaq);
      
      // Clear the input
      this.questionText = '';
    }
  }

  // Method to handle reaction clicks
  onReactionClick(type: 'like' | 'dislike', faqItem: any) {
    if (type === 'like') {
      faqItem.likes++;
    } else {
      faqItem.dislikes++;
    }
  }

  // Icons for like/dislike buttons
  getLikeIcon(type: 'like' | 'dislike'): string {
    if (type === 'like') {
      return `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="thumbs-up-icon" style="width: 16px; height: 16px">
        <path d="M9.73317 5.33335H13.9998C14.3535 5.33335 14.6926 5.47383 14.9426 5.72388C15.1927 5.97392 15.3332 6.31306 15.3332 6.66668V8.06935C15.3334 8.24359 15.2994 8.41618 15.2332 8.57735L13.1698 13.5874C13.1195 13.7095 13.034 13.8139 12.9242 13.8874C12.8144 13.9609 12.6853 14.0001 12.5532 14H1.33317C1.15636 14 0.98679 13.9298 0.861766 13.8048C0.736742 13.6797 0.666504 13.5102 0.666504 13.3334V6.66668C0.666504 6.48987 0.736742 6.3203 0.861766 6.19528C0.98679 6.07026 1.15636 6.00002 1.33317 6.00002H3.6545C3.76124 6.00004 3.86641 5.97445 3.96119 5.92537C4.05597 5.8763 4.13759 5.80519 4.19917 5.71802L7.83451 0.566684C7.88046 0.501559 7.94823 0.455058 8.02553 0.435611C8.10283 0.416164 8.18454 0.425059 8.25584 0.460684L9.46517 1.06535C9.80551 1.23546 10.0774 1.51689 10.2357 1.86289C10.3939 2.2089 10.429 2.59863 10.3352 2.96735L9.73317 5.33335Z" fill="#666C84"/>
      </svg>`;
    } else {
      return `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="thumbs-down-icon" style="width: 16px; height: 16px">
        <path d="M6.26651 10.6667H1.99984C1.64622 10.6667 1.30708 10.5262 1.05703 10.2761C0.80698 10.0261 0.666505 9.68695 0.666505 9.33333V7.93067C0.666325 7.75642 0.700299 7.58384 0.766505 7.42267L2.8305 2.41333C2.88069 2.29117 2.96603 2.18666 3.07571 2.11307C3.18538 2.03949 3.31443 2.00013 3.44651 2H14.6665C14.8433 2 15.0129 2.07024 15.1379 2.19526C15.2629 2.32029 15.3332 2.48986 15.3332 2.66667V9.33333C15.3332 9.51014 15.2629 9.67971 15.1379 9.80474C15.0129 9.92976 14.8433 10 14.6665 10H12.3452C12.2384 9.99997 12.1333 10.0256 12.0385 10.0746C11.9437 10.1237 11.8621 10.1948 11.8005 10.282L8.16517 15.4327C8.11922 15.4978 8.05145 15.5443 7.97415 15.5637C7.89685 15.5832 7.81514 15.5743 7.74384 15.5387L6.53451 14.9333C6.19417 14.7632 5.92228 14.4818 5.76402 14.1358C5.60575 13.7898 5.57064 13.4001 5.66451 13.0313L6.26651 10.6667Z" fill="#666C84"/>
      </svg>`;
    }
  }

  @HostListener('window:resize', [])
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 550;
    this.isBannerMobile = window.innerWidth <= 1000;
    this.isDownArrow = window.innerWidth <= 768;
    console.log('Is Mobile:', this.isMobile);
  }

  updateImageSize(image_url){
    const imgWidth = window.innerWidth
    const imgHeight = window.innerHeight
    const updatedUrl = `${image_url}/resize/${imgWidth}x${imgHeight}`;
    return updatedUrl;
  }


  onSubmit(){
    console.log('log')
  }
}
